import { EGameType } from '../enums'

export const gameTypeName: Record<EGameType, string> = {
  [EGameType.NLH]: "Hold'Em (NLH)",
  [EGameType.PLO4]: 'Omaha (PLO4)',
  [EGameType.PLO5]: 'Omaha (PLO5)',
}
